import React, { useEffect, useState } from "react"
import "./header-contact.scss"

const HeaderContact = props => {
  const { mobile, banner } = props

  const [pageLoad, setpageLoad] = useState(false)

  useEffect(() => {
    setpageLoad(true)
  }, [])

  return (
    <div className="f-header-contact">
      <img
        alt={banner[0].description}
        src={
          pageLoad
            ? banner[mobile ? 1 : 0].file.url
            : banner[mobile ? 1 : 0].fixed.base64
        }
        height={banner[mobile ? 1 : 0].file.details.image.height}
        className="f-banner-img"
      />
      <div className="f-header-contact-title">
        <h1 className="f-main-title">
          {process.env.LOCALE === "es-AR" ||
          process.env.LOCALE === "es-PY" ||
          process.env.LOCALE === "es-UY"
            ? "Contactanos"
            : "Contáctanos"}
        </h1>
      </div>
    </div>
  )
}

export default HeaderContact
